const builderArray = [];

/**
 * @class PackBuilder - Gestion du pack builder
 * @property {NodeList} products - Liste des produits du pack builder
 */

class PackBuilder extends HTMLElement {
  constructor() {
    super();

    this.products = document.querySelectorAll('.pack-builder-select');
    this.builder = document.querySelector('.pack-builder-wrapper');
    this.subscriptionsWidget = document.querySelector('subscriptions-widget');
    this.currencyCode = this.dataset.currencyCode;

    this.products.forEach((product) => {
      const addQuantityButton = product.querySelector('#pack-builder-plus');
      const minusQuantityButton = product.querySelector('#pack-builder-minus');

      addQuantityButton.addEventListener('click', () => {
        this.updateQuantity(product, 'add');
        this.addToBuilderArray(product);
        this.updateTotalPrice(product);
        if (this.subscriptionsWidget != null) this.updateSubWidgetPrices(product);
      });

      minusQuantityButton.addEventListener('click', () => {
        this.updateQuantity(product, 'subtract');
        this.removeFromBuilderArray(product);
        this.updateTotalPrice(product);
        if (this.subscriptionsWidget != null) this.updateSubWidgetPrices(product);
      });

      if (this.subscriptionsWidget != null) {
        // Listen to purchase type change
        this.subscriptionsWidget.querySelectorAll('input[name="purchase_type"]').forEach((input) => {
          input.addEventListener('change', (e) => {
            this.updateSubWidgetPrices(product);
            this.switchProductsPurchaseType(e.target.value);
          });
        });
        // Listen to frequency change
        document.addEventListener('custom-select-change', (e) => {
          this.switchSubFrequency(e.detail.value);
        });
      }
    });

    this.addToCartButton = document.querySelector('#pack-builder-add-to-cart');
    this.addToCartButton.addEventListener('click', this.addToShopifyCart.bind(this));

    this.addToCartButtonSticky = document.querySelector('#pack-builder-add-to-cart-sticky');
    this.addToCartButtonSticky.addEventListener('click', this.addToShopifyCart.bind(this));

    this.progressBarElement = document.querySelector('.pack-builder-gauge-container');
    this.discountElements = this.progressBarElement.querySelectorAll('[id^="pack-builder-gauge-"]');
    this.discounts = [];

    this.discountElements.forEach((element) => {
      let id = element.id;
      let discount = element.dataset.discount ? parseInt(element.dataset.discount) : 0;

      let seuil = id.replace('pack-builder-gauge-', '');
      this.discounts.push({
        seuil: seuil,
        discount: 1 - discount * 0.01,
      });
    });
  }

  updateQuantity(product, operation) {
    let inputElement = product.querySelector('input[type="number"]');
    let value = parseInt(inputElement.value);
    let newValue = operation === 'add' ? value + 1 : value - 1;
    const minusQuantityButton = product.querySelector('#pack-builder-minus');

    inputElement.value = newValue;
    minusQuantityButton.disabled = newValue === 0 ? true : false;

    this.updateRecapFlavor(product, operation);
  }

  updateRecapFlavor(product, operation) {
    const productId = product.dataset.id;
    const flavorElement = document.querySelector(`#pack-builder-recap-flavor-${productId}`);
    const flavorQuantityElement = flavorElement.querySelector('#pack-builder-recap-flavor-quantity');
    const flavorElementSticky = document.querySelector(`#pack-builder-recap-flavor-${productId}-sticky`);
    const flavorQuantityElementSticky = flavorElementSticky.querySelector('#pack-builder-recap-flavor-quantity');
    const quantity = parseInt(flavorQuantityElement.textContent);

    if (operation == 'add') {
      flavorElement.classList.remove('hidden');
      flavorQuantityElement.textContent = quantity + 1;
      flavorElementSticky.classList.remove('hidden');
      flavorQuantityElementSticky.textContent = quantity + 1;
    } else {
      let newQuantity = quantity - 1;
      flavorQuantityElement.textContent = newQuantity;
      flavorQuantityElementSticky.textContent = newQuantity;
      if (newQuantity <= 0) {
        flavorElement.classList.add('hidden');
        flavorElementSticky.classList.add('hidden');
      }
    }
  }

  updateTotalPrice(product) {
    const productPrice = product.dataset.price;
    const productPriceNumber = parseFloat(productPrice.replace(/[^0-9,\.]+/g, '').replace(',', '.'));
    const totalQuantity = builderArray.reduce((acc, item) => acc + item.quantity, 0);

    const totalPrice = document.querySelector('#pack-builder-add-to-cart-price');
    const totalStickyPrice = document.querySelector('#pack-builder-add-to-cart-sticky-price');
    let newTotalPrice = 0;
    let newTotalPriceDiscount = 0;

    let discount = this.checkDiscount(totalQuantity);

    newTotalPrice = productPriceNumber * totalQuantity;
    newTotalPriceDiscount = productPriceNumber * totalQuantity * discount;

    this.updateProgressBar(totalQuantity);
    this.updateUnitPrice(productPriceNumber, discount);
    this.updateTubeNumber(totalQuantity);
    this.updatePelletNumber(totalQuantity);

    if (newTotalPrice !== newTotalPriceDiscount) {
      totalPrice.innerHTML = `<s>${this.formatPrice(newTotalPrice)}</s> ${this.formatPrice(newTotalPriceDiscount)}`;
      totalStickyPrice.innerHTML = `<s>${this.formatPrice(newTotalPrice)}</s> ${this.formatPrice(newTotalPriceDiscount)}`;
    } else {
      totalPrice.textContent = this.formatPrice(newTotalPrice);
      totalStickyPrice.textContent = this.formatPrice(newTotalPrice);
    }
  }

  updateSubWidgetPrices(product) {
    const selectedPurchaseType = this.subscriptionsWidget.checkPurchaseType();
    const productPrice = parseFloat(product.dataset.price.replace(/[^0-9,\.]+/g, '').replace(',', '.'));
    const totalQuantity = builderArray.reduce((acc, item) => acc + item.quantity, 0);
    // check if the total quantity is eligible for a discount if it is add the percentage in the innerText of the class ".sw-purchase-type-label-text__saving" if it is not empty innertext of the class ".sw-purchase-type-label-text__saving"
    const qtyDiscount = this.checkDiscount(totalQuantity);
    const discountElement = document.querySelector('.sw-purchase-type-label-text__saving');
    if (qtyDiscount !== 1) {
      discountElement.innerText = `(-${Math.round((1 - qtyDiscount) * 100)}%)`;
    }
    if (qtyDiscount === 1) {
      discountElement.innerText = '';
    }

    const oneTimeTotalPriceContainer = document.querySelector('.sw-one-time-purchase--price');
    const subTotalComparePriceContainer = document.querySelector('.sw-subscription-purchase--compare-price');
    const subTotalPriceContainer = document.querySelector('.sw-subscription-purchase--price');
    const totalPriceContainer = document.querySelector('#pack-builder-add-to-cart-price');
    const totalStickyPriceContainer = document.querySelector('#pack-builder-add-to-cart-sticky-price');

    let newOneTimeTotalPrice = productPrice * totalQuantity;
    let discount = this.checkDiscount(totalQuantity);
    let newOneTimeTotalPriceDiscount = newOneTimeTotalPrice * discount;

    this.updateUnitPrice(productPrice, discount);

    const updatePriceContainers = (oneTimePrice, subComparePrice, subPrice, total, stickyTotal) => {
      oneTimeTotalPriceContainer.innerHTML =
        oneTimePrice !== newOneTimeTotalPriceDiscount
          ? `<s>${this.formatPrice(oneTimePrice)}</s> ${this.formatPrice(newOneTimeTotalPriceDiscount)}`
          : this.formatPrice(oneTimePrice);

      subTotalComparePriceContainer.innerHTML = this.formatPrice(oneTimePrice);
      subTotalPriceContainer.textContent = this.formatPrice(subPrice);
      totalPriceContainer.innerHTML =
        selectedPurchaseType === 'subscription' && oneTimePrice !== 0
          ? `<s>${this.formatPrice(oneTimePrice)}</s> ${this.formatPrice(subPrice)}`
          : oneTimePrice !== newOneTimeTotalPriceDiscount
            ? `<s>${this.formatPrice(oneTimePrice)}</s> ${this.formatPrice(newOneTimeTotalPriceDiscount)}`
            : this.formatPrice(oneTimePrice);

      totalStickyPriceContainer.innerHTML =
        selectedPurchaseType === 'subscription'
          ? `<s>${this.formatPrice(oneTimePrice)}</s> ${this.formatPrice(subPrice)}`
          : oneTimePrice !== newOneTimeTotalPriceDiscount
            ? `<s>${this.formatPrice(oneTimePrice)}</s> ${this.formatPrice(newOneTimeTotalPriceDiscount)}`
            : this.formatPrice(oneTimePrice);
    };

    let SubDiscount = this.subscriptionsWidget.dataset.discount;
    let newSubTotalPrice = productPrice * totalQuantity - (productPrice * totalQuantity * parseInt(SubDiscount, 10)) / 100;

    updatePriceContainers(newOneTimeTotalPrice, newOneTimeTotalPrice, newSubTotalPrice, newOneTimeTotalPrice, newOneTimeTotalPriceDiscount);
  }

  updateUnitPrice(price, discount) {
    const unitPriceElement = document.querySelector('#pack-builder-recap-price');
    const unitPriceElementSticky = document.querySelector('#pack-builder-recap-price-sticky');
    let subDiscount = null;
    if (this.subscriptionsWidget != null) subDiscount = this.subscriptionsWidget.dataset.discount;
    const subUnitPrice = price - (price * parseInt(subDiscount, 10)) / 100;

    if (this.subscriptionsWidget != null && this.subscriptionsWidget.checkPurchaseType() !== 'subscription') {
      if (discount === 1) {
        unitPriceElement.textContent = this.formatPrice(price);
        unitPriceElementSticky.textContent = this.formatPrice(price);
      } else {
        const discountPrice = price * discount;
        unitPriceElement.innerHTML = `<s>${this.formatPrice(price)}</s> ${this.formatPrice(discountPrice)}`;
        unitPriceElementSticky.innerHTML = `<s>${this.formatPrice(price)}</s> ${this.formatPrice(discountPrice)}`;
      }
    } else if (this.subscriptionsWidget != null && this.subscriptionsWidget.checkPurchaseType() === 'subscription') {
      unitPriceElement.innerHTML = `<s>${this.formatPrice(price)}</s> ${this.formatPrice(subUnitPrice)}`;
      unitPriceElementSticky.innerHTML = `<s>${this.formatPrice(price)}</s> ${this.formatPrice(subUnitPrice)}`;
    }
  }

  formatPrice(price) {
    switch (this.currencyCode) {
      case 'GBP':
        return '£' + price.toFixed(2).replace('.', ',');
        break;
      case 'USD':
        return '$' + price.toFixed(2).replace('.', ',');
        break;
      case 'EUR':
        return price.toFixed(2).replace('.', ',') + ' €';
        break;
      default:
        return price.toFixed(2).replace('.', ',') + ' €';
        break;
    }
  }

  updateTubeNumber(quantity) {
    const tubeElement = document.querySelector('#pack-builder-recap-tube');
    const tubeElementSticky = document.querySelector('#pack-builder-recap-tube-sticky');

    tubeElement.textContent = `${quantity} tube${quantity > 1 ? 's' : ''}`;
    tubeElementSticky.textContent = `${quantity} tube${quantity > 1 ? 's' : ''}`;
  }

  updatePelletNumber(quantity) {
    const pelletElement = document.querySelector('#pack-builder-recap-pellet');
    const pelletElementSticky = document.querySelector('#pack-builder-recap-pellet-sticky');

    pelletElement.textContent = `${quantity * 20} pastille${quantity > 0 ? 's' : ''}`;
    pelletElementSticky.textContent = `${quantity * 20} pastille${quantity > 0 ? 's' : ''}`;
  }

  updateProgressBar(totalQuantity) {
    const discounts = this.discounts.sort((a, b) => {
      return a.seuil - b.seuil;
    });

    for (let i = 0; i < discounts.length; i++) {
      const seuil = discounts[i].seuil;
      const element = this.progressBarElement.querySelector(`#pack-builder-gauge-${seuil}`);
      let progress = element.querySelector(`#pack-builder-progress-${seuil}`);

      if (totalQuantity >= seuil) {
        element.classList.add('active');
        progress.style.width = '100%';
      } else {
        element.classList.remove('active');
        if (i === 0) progress.style.width = `${(100 / seuil) * totalQuantity}%`;
        else progress.style.width = `${(100 / (seuil - discounts[i - 1].seuil)) * (totalQuantity - discounts[i - 1].seuil)}%`;
        break;
      }
    }
  }

  checkDiscount(totalQuantity) {
    this.discounts.sort((a, b) => b.seuil - a.seuil);

    for (let i = 0; i < this.discounts.length; i++) {
      if (totalQuantity >= this.discounts[i].seuil) {
        return this.discounts[i].discount;
      }
    }

    return 1;
  }

  addToBuilderArray(product) {
    const productId = product.dataset.id;
    const productIndex = builderArray.findIndex((product) => product.id === productId);
    const subFrenquencySelect = document.querySelector('.options-container');
    let subFrenquencySelected = null;
    if (subFrenquencySelect != null) subFrenquencySelected = subFrenquencySelect.querySelector('.custom-option--selected').dataset.value;
    let purchaseTypeSelected = 'one-time';
    if (this.subscriptionsWidget != null) {
      purchaseTypeSelected = this.subscriptionsWidget.checkPurchaseType();
    }

    if (productIndex !== -1) {
      if (purchaseTypeSelected !== 'subscription') {
        builderArray[productIndex].quantity += 1;
      } else {
        builderArray[productIndex].quantity += 1;
        builderArray[productIndex].selling_plan = subFrenquencySelected;
      }
    } else {
      if (purchaseTypeSelected !== 'subscription') {
        builderArray.push({
          id: productId,
          quantity: 1,
        });
      } else {
        builderArray.push({
          id: productId,
          quantity: 1,
          selling_plan: subFrenquencySelected,
        });
      }
    }

    this.addToCartButton.classList.remove('disabled');
    this.addToCartButtonSticky.classList.remove('disabled');
  }

  switchProductsPurchaseType(type) {
    if (type === 'subscription') {
      const productElements = document.querySelectorAll('.pack-builder-select');
      productElements.forEach((product) => {
        const productId = product.dataset.id;
        const productIndex = builderArray.findIndex((product) => product.id === productId);
        const subFrenquencySelect = document.querySelector('.options-container');
        let subFrenquencySelected = null;
        if (subFrenquencySelect != null)
          subFrenquencySelected = subFrenquencySelect.querySelector('.custom-option--selected').dataset.value;

        if (productIndex !== -1) {
          builderArray[productIndex].selling_plan = subFrenquencySelected;
        }
      });
    } else {
      const productElements = document.querySelectorAll('.pack-builder-select');
      productElements.forEach((product) => {
        const productId = product.dataset.id;
        const productIndex = builderArray.findIndex((product) => product.id === productId);

        if (productIndex !== -1) {
          delete builderArray[productIndex].selling_plan;
        }
      });
    }
  }

  switchSubFrequency(frequency) {
    const productElements = document.querySelectorAll('.pack-builder-select');
    productElements.forEach((product) => {
      const productId = product.dataset.id;
      const productIndex = builderArray.findIndex((product) => product.id === productId);

      if (productIndex !== -1) {
        builderArray[productIndex].selling_plan = frequency;
      }
    });
  }

  removeFromBuilderArray(product) {
    const productId = product.dataset.id;
    const productIndex = builderArray.findIndex((product) => product.id === productId);

    if (productIndex !== -1) {
      builderArray[productIndex].quantity -= 1;
      if (builderArray[productIndex].quantity <= 0) builderArray.splice(productIndex, 1);
    }

    if (builderArray.length <= 0) {
      this.addToCartButton.classList.add('disabled');
      this.addToCartButtonSticky.classList.add('disabled');
    }
  }

  addToShopifyCart() {
    if (!this.addToCartButton.classList.contains('disabled')) {
      this.addToCartButton.classList.add('disabled');
      this.addToCartButton.classList.add('loading');
      this.addToCartButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      this.addToCartButtonSticky.classList.add('disabled');
      this.addToCartButtonSticky.classList.add('loading');
      this.addToCartButtonSticky.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      mmAPIRequest('POST', 'cart/add.js', {
        items: builderArray,
        sections: mmGetSectionCartId(),
        sections_url: window.location.pathname,
      })
        .then(refreshCartFromData)
        .then((data) => {
          setTimeout(mmOpenCart);
        })
        .then(() => {
          this.addToCartButton.classList.remove('disabled');
          this.addToCartButton.classList.remove('loading');
          this.addToCartButton.querySelector('.loading-overlay__spinner').classList.add('hidden');

          this.addToCartButtonSticky.classList.remove('disabled');
          this.addToCartButtonSticky.classList.remove('loading');
          this.addToCartButtonSticky.querySelector('.loading-overlay__spinner').classList.add('hidden');
          document.querySelector('discount-popup').getGiftsNumber();
        })
        .catch((error) => {
          mmCartProductsContainerElement().innerHTML = `
                  Oups, il y a eu une erreur, essayez de recharger la page !
                  `;
          mmOpenCart();
          console.log(error);
        });
    }
  }
}

customElements.define('pack-builder', PackBuilder);

document.addEventListener('DOMContentLoaded', function () {
  let popupTitleElements = document.querySelectorAll('.pack-builder-popup-title');
  let closeIconElements = document.querySelectorAll('.icon-close');
  let overlayElement = document.querySelector('.pack-builder-overlay'); // Select overlay element
  let popupElementVariant = document.querySelector('.pack-builder-title-popup-container');

  popupTitleElements.forEach(function (popupTitleElement) {
    popupTitleElement.addEventListener('click', function () {
      let popupId = this.getAttribute('data-popup-id');
      let popupContainer = document.querySelector('.pack-builder-popup-container[data-popup-id="' + popupId + '"]');
      popupElementVariant.classList.toggle('active');
      overlayElement.classList.toggle('active');
      popupContainer.classList.remove('hidden');
      overlayElement.classList.remove('hidden'); // Show overlay
    });
  });

  closeIconElements.forEach(function (closeIconElement) {
    closeIconElement.addEventListener('click', function () {
      let popupId = this.closest('.pack-builder-popup-container').getAttribute('data-popup-id');
      let popupContainer = document.querySelector('.pack-builder-popup-container[data-popup-id="' + popupId + '"]');
      popupElementVariant.classList.remove('active');
      overlayElement.classList.remove('active');
      popupContainer.classList.add('hidden');
      overlayElement.classList.add('hidden'); // Hide overlay
    });
  });

  overlayElement.addEventListener('click', function () {
    popupElementVariant.classList.remove('active');
    overlayElement.classList.remove('active');
    let popupContainers = document.querySelectorAll('.pack-builder-popup-container');
    popupContainers.forEach(function (popupContainer) {
      popupContainer.classList.add('hidden');
    });
    overlayElement.classList.add('hidden'); // Hide overlay
  });
});

document.addEventListener('DOMContentLoaded', function () {
  let activePopup = null;

  let popupElements = document.querySelectorAll('.pack-builder-title-popup-container');
  let overlayElements = document.querySelectorAll('.pack-builder-overlay');

  function openPopup(popupElement) {
    popupElement.classList.add('active');
    overlayElements.forEach(function (overlayElement) {
      overlayElement.classList.add('active');
    });
    activePopup = popupElement;
  }

  function closeActivePopup() {
    if (activePopup) {
      activePopup.classList.remove('active');
      overlayElements.forEach(function (overlayElement) {
        overlayElement.classList.remove('active');
      });
      activePopup = null;
    }
  }

  popupElements.forEach(function (popupElement) {
    let popupTitle = popupElement.querySelector('.pack-builder-popup-title');
    let closeIcon = popupElement.querySelector('.icon-close');

    if (popupTitle) {
      popupTitle.addEventListener('click', function () {
        openPopup(popupElement);
      });
    }

    if (closeIcon) {
      closeIcon.addEventListener('click', function () {
        closeActivePopup();
      });
    }
  });

  overlayElements.forEach(function (overlayElement) {
    overlayElement.addEventListener('click', function () {
      closeActivePopup();
    });
  });

  var addToCart = document.getElementById('pack-builder-add-to-cart');
  var sticky = document.querySelector('.pack-builder-sticky');

  function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  function isAtBottom() {
    return window.innerHeight + window.pageYOffset >= document.body.scrollHeight;
  }

  function checkVisibility() {
    if (isElementInViewport(addToCart) || isAtBottom()) {
      sticky.style.display = 'none';
    } else {
      sticky.style.display = 'block';
    }
  }

  window.addEventListener('scroll', checkVisibility);
  checkVisibility();
});
